import React from 'react';
import { CaptionText } from '@prisjakt/ui/text/variants';
import { CheckboxSwitch } from '@prisjakt/ui/checkbox/variants';
import { IFilterOptionProps } from './types';
import { FilterOptionWrapper, CheckboxClickarea } from '../styles';

const FilterOption: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IFilterOptionProps>
>> = props => {
  const { name, defaultValue, onFilterChangedHandler, label, caption } = props;

  const onChangeHandler = (e?: React.ChangeEvent<HTMLInputElement>) => {
    e?.preventDefault();
    const newVal = !defaultValue;
    onFilterChangedHandler(name, newVal);
  };

  return (
    <FilterOptionWrapper>
      <CheckboxClickarea>
        <CheckboxSwitch
          id={name}
          text={label}
          onChange={onChangeHandler}
          checked={defaultValue}
        />
        {caption && <CaptionText container="div">{caption}</CaptionText>}
      </CheckboxClickarea>
    </FilterOptionWrapper>
  );
};

export default FilterOption;
